import React from "react";
import { textVariant } from "../../utils/motion";
import './index.css'
import { motion } from "framer-motion";
import SectionWrapper from "../../hoc/SectionWrapper";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { experiences } from "../../assets/constants";
const ExperienceCard = ({ experience }) => {
  return (
    <VerticalTimelineElement
      className=""
      contentStyle={{
        background: "#1d1836",
        color: "#fff",
        boxShadow: "none",
      }}
      contentArrowStyle={{ borderRight: "7px solid  #232631" }}
      date={experience.date}
      iconStyle={{ background: experience.iconBg }}
      icon={
        <div className="centerClass">
          <img src={experience.icon} alt={experience.company_name} className="containClass" />
        </div>
      }
    >
      <div>
        <h3 className="text-2xl kanit-semibold">{experience.title}</h3>
        {/* <p className="text-4xl">{experience.company_name}</p> */}
      </div>

      <div className="listClass">
        {experience.points.map((point, index) => (
          <p key={`experience-point-${index}`} className=" line-height-6">
            {point}
          </p>
        ))}
      </div>
    </VerticalTimelineElement>
  );
};


const SplitTimeline = () => {
    return (
      <>
        <motion.div variants={textVariant()} id="Timeline">
          <p className={`sectionSubText text-center`}>What I have done so far</p>
          <h2 className={`sectionHeadText text-center`}>Work Experience</h2>
        </motion.div>

        <div style={{ marginTop: 20, display: "flex", flexDirection: "column" }}>
          <VerticalTimeline>
            {experiences.map((experience, index) => (
              <ExperienceCard key={`experience-${index}`} experience={experience} />
            ))}
          </VerticalTimeline>
        </div>
      </>
    );
};

export default SectionWrapper(SplitTimeline,'experience');
